<ul>
    <li *ngFor="let client of clients; let clientIndex=index">
        <div class="bold">
            {{client.fullName? client.fullName : 'New Client'}}</div>
        <ul>
            <li *ngFor="let topic of cirfClientTopics; let topicIndex=index">
                <ul>
                    <li *ngFor="let section of topic.topicSections; let sectionIndex=index">

                            <i class="fa fa-check-circle green" *ngIf="isClientSectionVisible(client, section) && isExistingAccessNavSection(clientIndex, section.sectionKey) && !isSectionHasErrors(clientIndex, section.sectionKey)"></i>
                            <i class="fa fa-times-circle red" *ngIf="isClientSectionVisible(client, section) && isExistingAccessNavSection(clientIndex, section.sectionKey) && isSectionHasErrors(clientIndex, section.sectionKey)"></i>
                            <a *ngIf="isClientSectionVisible(client, section)"
                                [ngClass]="{'active' : cirfNavigation?.selectedSectionKey == section.sectionKey && cirfNavigation?.selectedClientIndex == clientIndex}"
                                (click)="onSelectSection(clientIndex, topic.topicKey, section.sectionKey,client, -1, -1 )">
                                {{section.sectionName}}</a>
                            <span *ngIf="!isClientSectionVisible(client, section)">{{section.sectionName}}</span>


                    </li>
                </ul>
            </li>

        </ul>
    </li>
</ul>
<ul>
    <li *ngFor="let topic of cirfOtherTopics; let topicIndex=index">
        <ng-container *ngIf="isTransactionDetailApplicable(topic.topicKey)">
            <div class="bold">
                {{topic.topicName}}
            </div>
            <ul>
                <li *ngFor="let section of topic.topicSections; let sectionIndex=index">
                    <ng-container *ngIf="isSectionVisible(section)">
                        <i class="fa fa-check-circle green" *ngIf="isExistingAccessNavSection(-1, section.sectionKey) && !isSectionHasErrors(-1, section.sectionKey)"></i>
                        <i class="fa fa-times-circle red" *ngIf="isExistingAccessNavSection(-1, section.sectionKey) && isSectionHasErrors(-1, section.sectionKey)"></i>
                        <a [ngClass]="{'active' : cirfNavigation?.selectedSectionKey == section.sectionKey}"
                                (click)="onOtherTopicSelection(topic.topicKey, section.sectionKey)">
                            {{section.sectionName}}</a>
                    </ng-container>

                </li>
            </ul>
        </ng-container>
    </li>
</ul>
<ul *ngIf="(cirf?.isMatterPurchase() || cirf?.isMatterMortgage()) && cirf?.isMatterCirf() && !cirf?.isCustomMatter()">
    <li>
        <div class="bold">
            <span *ngIf="cirf?.cirfMatterData?.newMortgages?.length">Mortgage / Loan Details</span>
            <a *ngIf="!cirf?.cirfMatterData?.newMortgages?.length" class="cursor-pointer" (click)="onAddNewMortgage()">Mortgage / Loan Details</a>
        </div>
        <ul *ngIf="cirf?.cirfMatterData?.newMortgages?.length">
            <li *ngFor="let mortgage of cirf?.cirfMatterData?.newMortgages; let mortgageIndex=index">
                <i class="fa fa-check-circle green" *ngIf="isExistingAccessNavSection(-1, null, mortgageIndex) && !isSectionHasErrors(-1, null, mortgageIndex)"></i>
                <i class="fa fa-times-circle red" *ngIf="isExistingAccessNavSection(-1, null, mortgageIndex) && isSectionHasErrors(-1, null, mortgageIndex)"></i>
                <a [ngClass]="{'active' : cirfNavigation?.selectedNewMortgageIndex == mortgageIndex}"
                   (click)="onSelectSection(-1, null, null, undefined ,mortgageIndex, -1)">
                    {{mortgage.bankName? mortgage.bankName : 'New Mortgage'}}</a>
            </li>
        </ul>
    </li>
</ul>
<!--New Mortgage Notes-->
<ul *ngIf="(cirf?.isMatterPurchase() || cirf?.isMatterMortgage()) && cirf?.isMatterCirf() && !cirf?.isCustomMatter()">
    <li *ngFor="let topic of cirfNewMortgageNotes; let topicIndex=index">
        <div class="bold">
            <span>{{topic.topicName}}</span>
        </div>
        <ul>
            <li *ngFor="let section of topic.topicSections; let sectionIndex=index">
                <i class="fa fa-check-circle green" *ngIf="isExistingAccessNavSection(-1, section.sectionKey) && !isSectionHasErrors(-1, section.sectionKey)"></i>
                <i class="fa fa-times-circle red" *ngIf="isExistingAccessNavSection(-1, section.sectionKey) && isSectionHasErrors(-1, section.sectionKey)"></i>
                <a [ngClass]="{'active' : cirfNavigation?.selectedSectionKey == section.sectionKey}"
                   (click)="onSelectSection(-1, topic.topicKey,  section.sectionKey, undefined)">
                    {{section.sectionName}}</a>
            </li>
        </ul>
    </li>
</ul>

<ul *ngIf="cirf?.isMatterCirf() && (cirf?.isMatterSale() || cirf?.isMatterMortgage())">
    <li>
        <div class="bold">
            <span *ngIf="cirf?.cirfMatterData?.existingMortgage?.length">Existing Mortgage / Loan Details</span>
            <a *ngIf="!cirf?.cirfMatterData?.existingMortgage?.length" class="cursor-pointer" (click)="onAddExistingMortgage()">Existing Mortgage / Loan Details</a>
        </div>
        <ul *ngIf="cirf?.cirfMatterData?.existingMortgage?.length">
            <li *ngFor="let mortgage of cirf?.cirfMatterData?.existingMortgage; let mortgageIndex=index">
                <i class="fa fa-check-circle green" *ngIf="isExistingAccessNavSection(-1, null, -1, mortgageIndex) && !isSectionHasErrors(-1, null, -1, mortgageIndex)"></i>
                <i class="fa fa-times-circle red" *ngIf="isExistingAccessNavSection(-1, null, -1, mortgageIndex) && isSectionHasErrors(-1, null, -1, mortgageIndex)"></i>
                <a [ngClass]="{'active' : cirfNavigation?.selectedExistingMortgageIndex == mortgageIndex}"
                   (click)="onSelectSection(-1, null, null,undefined, -1, mortgageIndex)">
                    {{mortgage.bankName? mortgage.bankName : 'Existing Mortgage'}}</a>
            </li>
        </ul>
    </li>
</ul>
<!--Existing Mortgage Notes-->
<ul *ngIf="cirf?.isMatterCirf() && (cirf?.isMatterSale() || cirf?.isMatterMortgage())">
    <li *ngFor="let topic of cirfExistingMortgageNotes; let topicIndex=index">
        <div class="bold">
            <span>{{topic.topicName}}</span>
        </div>
        <ul>
            <li *ngFor="let section of topic.topicSections; let sectionIndex=index">
                <i class="fa fa-check-circle green" *ngIf="isExistingAccessNavSection(-1, section.sectionKey) && !isSectionHasErrors(-1, section.sectionKey)"></i>
                <i class="fa fa-times-circle red" *ngIf="isExistingAccessNavSection(-1, section.sectionKey) &&isSectionHasErrors(-1, section.sectionKey)"></i>
                <a [ngClass]="{'active' : cirfNavigation?.selectedSectionKey == section.sectionKey}"
                   (click)="onSelectSection(-1, topic.topicKey,  section.sectionKey, undefined)">
                    {{section.sectionName}}</a>
            </li>
        </ul>
    </li>
</ul>

<ul>
    <li *ngFor="let topic of cirfAdditionalNotes; let topicIndex=index">
        <div class="bold">{{topic.topicName}}</div>
        <ul>
            <li *ngFor="let section of topic.topicSections; let sectionIndex=index"
                [ngClass]="{'bold margin-left-minus-10 padding-top-10' : isSectionReviewSubmit(section.sectionKey)}"
            >
                <a  [ngClass]="{'active' : cirfNavigation?.selectedSectionKey == section.sectionKey}"
                    (click)="onSelectSection(-1, topic.topicKey, section.sectionKey, undefined)">
                    {{section.sectionName}}</a>
            </li>
        </ul>
    </li>
</ul>
